import { UserAmilearnStatus } from '../core/services/user/user.type';
import { AppRoute, openAppRoutes, userStatusRoutingTable } from './routing.config';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root'
})
export class RoutingUtils {
  constructor(private logger: NGXLogger) {}

  routeForUserStatus(userStatus: UserAmilearnStatus): AppRoute {
    return userStatusRoutingTable[userStatus] || AppRoute.APP_LOGIN;
  }

  isOpenRouteForPath(path: string): boolean {
    const r = this.appRouteFromPath(path);
    if (r) {
      this.logger.debug(`[RoutingUtils] route: ${r}`);
      const f = this.isOpenRoute(r);
      this.logger.debug(`[RoutingUtils] f: ${f}`);
      return f;
    } else {
      return false;
    }
  }

  appRouteFromPath(path: string): AppRoute | null {
    for (const v in AppRoute) {
      if (path.includes(AppRoute[v as AppRoute])) {
        this.logger.debug(`[RoutingUtils] - appRouteFromPath: found: ${v} -> `);
        return AppRoute[v];
      }
    }
    this.logger.debug(`[RoutingUtils] nothing found`);

    return null;
  }

  isOpenRoute(route: AppRoute): boolean {
    this.logger.debug(`[RoutingUtils] - isOpenRoute: incoming route: `, route);

    return openAppRoutes.includes(route);
  }

  routeToExternalUrl(url: string): void {
    this.logger.debug(`[RoutingUtils] - routeToExternalUrl: `, url);
    window.location.href = url;
  }
}
